/**
 * Mutates {@link obj} and set new name specified in {@link newKeyName} to a key with name specified in {@link keyToRename}
 *
 * @param {Object} obj - Mutated object.
 * @param {string} keyToRename - Key's old name.
 * @param {string} newKeyName - Key's new name.
 */
export function renameObjectField(obj, keyToRename, newKeyName) {
    delete Object.assign(obj, { [newKeyName]: obj[keyToRename] })[keyToRename];
}
